module.exports = __webpack_public_path__ + "img/smallStarBlue.f29e05b8.svg";